import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { RoomWallHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomWallHeatLossDetailsFormModel';

export type CreateUpdateRoomWallHeatLossDetailsDto = {
  displayIndex: number;
  outsideWallLengthInMetres: number | null;
  additionalWallAreaInMetresSquared: number | null;
  windowAreaInMetresSquared: number | null;
  doorAreaInMetresSquared: number | null;
  externalAirTemperatureInDegreesCelsius: number | null;
};

export const mapRoomWallHeatLossDetailsFormModelToDto = (
  formModel: RoomWallHeatLossDetailsFormModel,
  displayIndex: number,
): CreateUpdateRoomWallHeatLossDetailsDto => ({
  displayIndex,
  outsideWallLengthInMetres: assertIsNumberOrNull(formModel.outsideWallLengthInMetres),
  additionalWallAreaInMetresSquared: assertIsNumberOrNull(formModel.additionalWallAreaInMetresSquared),
  windowAreaInMetresSquared: assertIsNumberOrNull(formModel.windowAreaInMetresSquared),
  doorAreaInMetresSquared: assertIsNumberOrNull(formModel.doorAreaInMetresSquared),
  externalAirTemperatureInDegreesCelsius: assertIsNumberOrNull(formModel.externalAirTemperatureInDegreesCelsius),
});
